import { render, staticRenderFns } from "./AccessibilitySettings.vue?vue&type=template&id=39ac9e57&scoped=true&"
import script from "./AccessibilitySettings.vue?vue&type=script&lang=js&"
export * from "./AccessibilitySettings.vue?vue&type=script&lang=js&"
import style0 from "./AccessibilitySettings.vue?vue&type=style&index=0&id=39ac9e57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ac9e57",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VDivider,VIcon,VRow})
